import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import VideoInputContainer from '../inputs/VideoInputContainer';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import TextInput from '../../../../core/form/TextInput';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const VideoLongItemForm = (props) => (
  <div>
    <TextInput
      label="Title"
      disabled={props.submitting || props.disabled}
      value={get(props.values, 'title', '')}
      onChange={(value) => props.onChange('title', value)}
      errorText={get(props.errors, 'title', '')}
    />
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <TranslationInputContainer
      onChange={props.onChange}
      submitting={props.submitting}
      values={props.values}
      errors={props.errors}
      disabled={props.disabled}
    />
    <VideoInputContainer
      onChange={props.onChange}
      errors={props.errors}
      values={props.values}
      submitting={props.submitting}
      requiredCut={false}
      disabled={props.disabled}
    />
    <Row>
      <Column size={5}>
        <LocalFileInput
          label="English Subtitle"
          accept="subtitle"
          value={get(props.values, 'englishSubtitle', null)}
          onChange={(value) => props.onChange('englishSubtitle', value)}
          disabled={props.disabled}
          errorText={get(props.errors, 'englishSubtitle', null)}
        />
      </Column>
    </Row>
  </div>
);

VideoLongItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  isTestItem: PropTypes.bool,
};

VideoLongItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
  isTestItem: false,
};

export default VideoLongItemForm;
